import { FiX } from 'react-icons/fi';
import { Container, Mask } from './style';

interface Props {
  children?: React.ReactNode;
  setOpenModalSelectedProduct: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalProduct = ({ children, setOpenModalSelectedProduct }: Props) => {
  return (
    <Mask>
      <Container>
        <button
          className="close-modal"
          type="button"
          onClick={() => setOpenModalSelectedProduct(false)}
        >
          <FiX size={24} />
        </button>
        <div className="header">
          <p>Produto selecionado</p>
        </div>

        {children}
      </Container>
    </Mask>
  );
};

export default ModalProduct;
